module.exports = __webpack_public_path__ + "static/media/46980020-NrUzwSgs.b3bc2f2c.JPG";